import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './button.module.css'

type ButtonAnchorHTMLAttributes = React.ButtonHTMLAttributes<
  HTMLButtonElement
> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

interface IProps extends ButtonAnchorHTMLAttributes {
  large?: boolean
  primary?: boolean
  fixedWidth?: boolean
}

const Button = (props: IProps) => {
  const {
    className,
    children,
    large,
    primary,
    fixedWidth,
    ...nextProps
  } = props
  const Tag = nextProps.href ? 'a' : 'button'
  const nextClassName = classnames(styles.button, className, {
    [styles.large]: large,
    [styles.primary]: primary,
    [styles.fixedWidth]: fixedWidth
  })

  return (
    <Tag className={nextClassName} {...nextProps}>
      {children}
    </Tag>
  )
}

export default Button



// WEBPACK FOOTER //
// ./client/components/button/button.tsx